import services from '@/http'
import * as storage from '../storage'
import * as types from './mutation-types'

export const ActionVerifyConfirmation = ({ commit }, payload) => {
  return services.auth.verifyConfirmation(payload).then(res => {
    if (res.data.data) {
      commit(types.SET_VERIFIED, res.data.data.confirmed)
      commit(types.SET_WAITING_CODE, !res.data.data.confirmed)
      commit(types.SET_HAS_PASSWORD, res.data.data.hasPassword)

      return true;
    } else {
      return false;
    }
  })
}

export const ActionConfirmation = ({ commit }, payload) => {
  return services.auth.confirmation(payload).then(res => {
    commit(types.SET_VERIFIED, res.data.data.confirmed)
    commit(types.SET_WAITING_CODE, !res.data.data.confirmed)
    commit(types.SET_CODE_ERROR, !res.data.data.confirmed)
    commit(types.SET_HAS_PASSWORD, res.data.data.hasPassword)
  });
}

export const ActionConfirmToResetPass = ({ commit }, payload) => {
  return services.auth.confirmation(payload).then(res => {
    commit(types.SET_VERIFIED, res.data.data.confirmed)
    commit(types.SET_WAITING_CODE, !res.data.data.confirmed)
    commit(types.SET_CODE_ERROR, !res.data.data.confirmed)
    commit(types.SET_HAS_PASSWORD, false)
  });
}

export const ActionResetPassword = ({ commit }, payload) => {
  return services.auth.forgotPassword(payload).then(res => {
    if (res.data.data) {
      commit(types.SET_VERIFIED, res.data.data.confirmed)
      commit(types.SET_WAITING_CODE, !res.data.data.confirmed)
      commit(types.SET_WAITING_RESET_CODE, !res.data.data.confirmed)
      commit(types.SET_HAS_PASSWORD, 0)
      return true;
    } else {
      return false;
    }
  })
}

export const ActionCreatePassword = ({ commit }, payload) => {

  return services.auth.createPassword(payload).then(res => {
    commit(types.SET_HAS_PASSWORD, res.data.data)
  });

}

export const ActionLogin = ({ dispatch }, payload) => {
  return services.auth.login(payload).then(res => {
    dispatch('ActionSetGuest', res.data.data.guest)
    dispatch('ActionSetToken', res.data.data.token)
  });
}

export const ActionLoginFacebook = () => {
  return services.auth.facebookLogin().then(res => {
    if (res.status) {
      return res.data.data;
    }
    throw new Error('Erro interno!');
  });
}



export const actionConfirmAcessWithFacebook = ({ dispatch }, code, state) => {
  return services.auth.facebookCheck(code, state).then(res => {
    if (res.body.data) {
      dispatch('ActionSetGuest', res.data.data.guest)
      dispatch('ActionSetToken', res.data.data.token)
      return dispatch('ActionLoadSession')
    } else if (res.body.message === "not found user") {
      throw new Error('Not found')
    } else {
      throw new Error('Erro interno!')
    }
  })
}
export const ActionLoginGoogle = () => {
  return services.auth.loginGoogle().then(res => {
    if (res.body.data) {
      return res.body.data
    }
    throw new Error('Erro interno!');
  })
}

export const AuthenticateGoogle = ({ dispatch }, payload) => {
  return services.auth.authGoogle(payload).then(res => {
    if (res.body.data) {
      dispatch('ActionSetGuest', res.data.data.guest)
      dispatch('ActionSetToken', res.data.data.token)
      return dispatch('ActionLoadSession')
    }
    throw new Error('Erro interno!');

  })
}

export async function getFingerprint() {
  var navigatorInfo = window.navigator;
  var screenInfo = window.screen;
  var uid = navigatorInfo.userAgent.replace(/\D+/g, '');
  uid += screenInfo.height || '';
  uid += screenInfo.width || '';
  uid += screenInfo.pixelDepth || '';
  uid += navigatorInfo.language || '';
  uid += new Date().getTimezoneOffset() || '';
  uid += navigatorInfo.hardwareConcurrency || '';
  uid += navigatorInfo.deviceMemory || '';
  uid += JSON.stringify(navigatorInfo.mediaDevices) || '';
  uid += navigatorInfo.maxTouchPoints || '';

  const msgUint8 = new TextEncoder().encode(uid);
  const hashBuffer = await crypto.subtle.digest('SHA-256', msgUint8);
  const hashArray = Array.from(new Uint8Array(hashBuffer));
  const hashHex = hashArray.map(b => b.toString(16).padStart(2, '0')).join('');
  return hashHex;
}


export const ActionLoginX = async () => {
  const fingerprint = await getFingerprint();

  return services.auth.loginX({ cochall: fingerprint }).then(res => {
    if (res.data) return res.data.data
    throw new Error('Erro interno!');
  })
}

export const AuthenticateX = async ({ dispatch }, payload) => {

  let payloadData = {
    ...payload,
    cochall: await getFingerprint(),
    code_challenge_method: 'S256',
  }

  return services.auth.authX(payloadData).then(res => {
    if (res.body.data) {
      dispatch('ActionSetGuest', res.data.data.guest)
      dispatch('ActionSetToken', res.data.data.token)
      return dispatch('ActionLoadSession')
    }
    throw new Error('Erro interno!');
  })
}

export const ActionCheckToken = ({ dispatch, state }) => {
  if (state.token) {
    return Promise.resolve(state.token)
  }

  const token = storage.getLocalToken()

  if (!token) {
    return Promise.reject(new Error('Token Inválido'))
  }

  dispatch('ActionSetToken', token)
  return dispatch('ActionLoadSession')
}




export const ActionLoadSession = ({ dispatch }) => {
  return new Promise((resolve, reject) => {
    (async () => {

      try {
        const { data: { data: { guest } } } = await services.auth.loadSession()

        dispatch('ActionSetGuest', guest)
        resolve()
      } catch (err) {
        dispatch('ActionSignOut')
        reject(err)
      }

    })();
  });
}


export const ActionSetGuest = ({ commit }, payload) => {
  commit(types.SET_GUEST, payload)
}

export const ActionSetToken = ({ commit }, payload) => {
  storage.setLocalToken(payload)
  storage.setHeaderToken(payload)
  commit(types.SET_TOKEN, payload)
}

export const ActionSignOut = ({ dispatch, commit }) => {
  storage.setHeaderToken('')
  storage.deleteLocalToken()
  dispatch('ActionSetGuest', {})
  dispatch('ActionSetToken', '')
  commit(types.RESET_STATE)
}
